import React, { useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import useStyles from './useStyles';
import { BoxRounded } from '../../../../components/BoxRounded';

import { CarouselSlider } from '../../../../components/CarouselSlider';
import { LandingContext } from '../../../../context/landing';

export const BanksCarrousel = () => {
  const classes = useStyles();
  const { landingData } = useContext(LandingContext);

  const { dataInfoTag = {} } = landingData;

  const { show = false } = dataInfoTag;

  if (!show) return null;

  return (
    <Box component="section" className={classes.sectionContainer}>
      {
        dataInfoTag?.title && (
          <Typography className={classes.tagTitle} component="h2">
            {dataInfoTag.title}
          </Typography>
        )
      }
      <BoxRounded
        title={dataInfoTag?.subtitle || ''}
      >
        <CarouselSlider
          images={dataInfoTag.images}
          classNames={{
            img: classes.img,
            imgContainer: classes.imgContainer,
          }}
        />

      </BoxRounded>
    </Box>
  );
};
